<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  // RO Polyfill for older browsers
  //import ResizeObserver from 'resize-observer-polyfill';

  export let showScrollbar = true;
  export let containerHeight: number;

  export function slide(val) {
    if (val == null) return;
    if (viewport.children.length == 0) {
      viewport.scrollLeft = 0;
      return;
    };
    let w = viewport.children[0].clientWidth;
    viewport.scrollLeft = val*w;
  }
  export let progress: number = 0;
  let viewport;

  function onScroll(e) {
    progress = viewport.scrollLeft/(viewport.scrollWidth-viewport.clientWidth);
  }

//   let resize_obs = new ResizeObserver(entries=> {
//     if (viewport != null) {
//       viewport.scrollBy(0,0);
//     }
//   });
//   onMount(()=>{
//     resize_obs.observe(viewport);
//   })
//   onDestroy(()=>{
//     resize_obs.unobserve(viewport);
//     resize_obs.disconnect();
//   })

  $: containerWidth = "max-width: " + (containerHeight * 1.75) + "px;";

</script>

<flex-container class:scrollbar={showScrollbar} style={containerWidth} bind:this={viewport} on:scroll={onScroll}>
  <slot/>
</flex-container>

<style lang="scss">
  flex-container {
    display: flex;
    flex-direction: row;
    align-content: stretch;
    overflow: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;

    &.scrollbar {
      overflow-x: scroll;
    }
  }
</style>
